import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiResource } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { Observable } from 'rxjs';
import {
  ETransportCommercialDataCollaborationDtoModel,
  ETransportShipmentDataCollaborationDtoModel,
} from '@well/delivery-libs/etransport/domain-model';

@Injectable({
  providedIn: 'root',
})
export class ETransportCollaborationResourceService extends AbstractResourceService<null, null, null, null> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('eTransportCollaborationUrl'));
  }

  sendCommercialDataInvitationEmail(eTransportNotificationUuid: string): Observable<any> {
    return this.httpClient?.post(`${this.url}/email/commercial-data`, eTransportNotificationUuid);
  }

  sendShipmentDataInvitationEmail(eTransportNotificationUuid: string): Observable<any> {
    return this.httpClient?.post(`${this.url}/email/shipment-data`, eTransportNotificationUuid);
  }

  getCommercialDataTemplate(notificationUuid: string) {
    return this.httpClient?.get<JsonApiResource<ETransportCommercialDataCollaborationDtoModel, null>>(
      `${this.url}/template/commercial-data/${notificationUuid}`
    );
  }

  getShipmentDataTemplate(notificationUuid: string) {
    return this.httpClient?.get<JsonApiResource<ETransportShipmentDataCollaborationDtoModel, null>>(
      `${this.url}/template/shipment-data/${notificationUuid}`
    );
  }

  patchCommercialData(eTransportCommercialDataCollaborationDTO: ETransportCommercialDataCollaborationDtoModel) {
    return this.httpClient?.patch<JsonApiResource<ETransportCommercialDataCollaborationDtoModel, null>>(
      `${this.url}/commercial-data`,
      eTransportCommercialDataCollaborationDTO
    );
  }

  patchShipmentData(eTransportShipmentDataCollaborationDTO: ETransportShipmentDataCollaborationDtoModel) {
    return this.httpClient?.patch<JsonApiResource<ETransportShipmentDataCollaborationDtoModel, null>>(
      `${this.url}/shipment-data`,
      eTransportShipmentDataCollaborationDTO
    );
  }
}
